function updateHierarchyNavURLs() {
  url = window.location.href;
  var coll_filter_el = document.getElementById("romarah_coll_filter");
  const coll_filter = (coll_filter_el != null)? coll_filter_el.textContent: '';
  
  const parts = url.split("?");
  if (parts.length > 1 || coll_filter.length > 0) {
    const navLinks = document.getElementsByClassName("rm-nav-link");        
    for (let i = 0; i < navLinks.length; i++) {
      const link_parts = navLinks[i].firstChild.href.split("?");
      var query = '';
      if (coll_filter.length > 0) { /* if we're on a collection that corresponds to a filter, keep that part in the links */
        query = '?' + coll_filter; 
      } 
      if (parts.length > 1) {
        query = query + ((query.length > 0)? '&': '?') + parts[1];
      }
      navLinks[i].firstChild.href = link_parts[0] + query;
    }
  }

  var nl_parent = document.getElementById("romarah_nav_links");
  if (nl_parent != null) {
    nl_parent.classList.remove("hidden");  
  }  
  /* if not on an actual collection page with embedded filter, but based on the query 
   * params the user started from such a collection, write collection into breadcrumbs 
   */
  var custom_params_for_hbc = '';
  var custom_params_for_pagination = '';
  if (coll_filter.length == 0 && parts.length > 1) {
    var result = {};
    parts[1].split("&").forEach(function(part) {
      var item = part.split("=");
      result[item[0]] = item[1];
    });
    if (result.hasOwnProperty('rm.c.t') && result.hasOwnProperty('rm.c.h')) {
      var bc_cont = document.getElementsByClassName("breadcrumbs-container");
      var title = result['rm.c.t'];
      title = decodeURIComponent(title.replace("+", " "));
      var a = document.createElement("a");
      a.href = `/collections/${result['rm.c.h']}`;
      a.innerText = title;
      var delimeter = document.createElement("span");
      delimeter.classList.add("breadcrumbs-delimiter");
      delimeter.setAttribute('aria-hidden','true');
      delimeter.innerHTML = `<svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5"><path fill="currentColor" fill-rule="evenodd" d="M1.002.27L.29.982l3.712 3.712L7.714.982 7.002.27l-3 3z"></path></svg>`;
      bc_cont[0].insertBefore(a, bc_cont[0].firstElementChild.nextElementSibling);
      bc_cont[0].insertBefore(delimeter, bc_cont[0].firstElementChild.nextElementSibling);

      /* also write the injected first order breadcrump into the collection name */
      const heading = document.querySelector('h1.collection--title');
      heading.textContent = title + ' ' + heading.textContent;

      if (result.hasOwnProperty('rm.c.f')) {
        /* hierarhcy links within breadcrumbs */
        custom_params_for_pagination = "rm.c.f=" + result['rm.c.f'] + "&rm.c.h=" + result['rm.c.h'] + "&rm.c.t=" + result['rm.c.t'];
        custom_params_for_hbc = decodeURIComponent(result['rm.c.f']) + "&" + custom_params_for_pagination;
        const hierBreadLinks = document.getElementsByClassName("hier");
        for (let i = 0; i < hierBreadLinks.length; i++) {
          const hbc_parts = hierBreadLinks[i].href.split("?");
          hierBreadLinks[i].href = hbc_parts[0] + "?" + custom_params_for_hbc;
        }
      }
    }
  }
  return custom_params_for_pagination;
}

function fixPagination(custom_params) {
  if (custom_params != '') {
    const paginationLinks = document.getElementsByClassName("pagination--item");
    for (var i = 0; i < paginationLinks.length; i++) {
      if (paginationLinks[i].tagName == "A") { /* exclude spans */
        paginationLinks[i].href = paginationLinks[i].href + ((paginationLinks[i].href.split('?').length > 0)? '&': '?') + custom_params;
      }
    }
  }
    
}

/* ensure all filters in the URL are shown in the active filters section, so any of them can be removed. this may require adding the active filters element or simply adding to it */
function fixActiveFiltersElement () {
  const currentSearch = window.location.search.replace('?', '');
  if (currentSearch != '') {
    const currParams = new URLSearchParams(currentSearch); 
    var currFilters = new URLSearchParams();
    for (const p of currParams) {
      if (p[0].substring(0, 9) == 'filter.p.') {
        currFilters.append(p[0], p[1]);  
      }
    }
    if (currFilters.size > 0) {
      var origFilterCount = 0;
      var needToAdd = new URLSearchParams();

      /* mobile and non-mobile filters sections have diff parent elements but same contents, so study one then update both */
      var activeFiltersElements = document.getElementsByClassName("productgrid--filters");
      var activeFiltersElementsMobile = document.getElementsByClassName("productgrid--filters--mobile");
      
      /* make sure active filters element contains all filters, else add missing ones */
      if (activeFiltersElements.length > 0) {
        console.log(document.getElementsByClassName("productgrid--filters")[0].firstElementChild.children);
        var activeFilters = activeFiltersElements[0].firstElementChild.children;
        origFilterCount = (activeFiltersElements[0].firstElementChild.children.length) - 1;
        for (const c of currFilters) {
          var foundIt = false;
          for (let i = 0; i < activeFilters.length; i++) {
            if (!activeFilters[i].classList.contains('active-filter-group--remove-all')) {
              /* not reliable to compare filter text because diff filter types can have same val, so compare its URL with current */
              var url_without_this_parts = activeFilters[i].querySelector(".active-filter-group__item").dataset.url.split('?');
              if (url_without_this_parts.length > 0) {
                const paramsWithoutCurrFilter = new URLSearchParams(url_without_this_parts[1]); 
                var this_key = null; var this_val = null;
                for (const p of currParams) {
                  if (p[0].substring(0, 9) == 'filter.p.') {
                    var is_this = true;
                    for (const pwc of paramsWithoutCurrFilter) {
                      if (pwc[0] == p[0] && pwc[1] == p[1]) {
                        is_this = false;
                      }
                    }
                    if (is_this) {
                      this_key = p[0]; this_val = p[1];
                      break;
                    }
                  }
                }
                if (
                    (this_key == c[0] && this_val == c[1]) 
                    || (
                      this_key != null
                      && this_key.substring(0, 9) == 'filter.v.' /* never add price filter, they will always be present */
                    )
                ) {
                  foundIt = true;
                } 
              }
            }
          }
          if (!foundIt) {
            needToAdd.append(c[0], c[1]);
          }
        } 
      } else {/* build active filters elements and prepare to fill them */
        needToAdd = currFilters;
        const filterSkeleton = `
          <ul class="active-filter-group">
            <li class="active-filter-group--remove-all filter-item--grid-simple">
              <a class="filter-item-clear-all" href="${location.pathname}">Clear all</a>
            </li>
          </ul>
        `;
        /* regular */
        var act_filt_el = document.createElement("div");
        act_filt_el.classList.add("productgrid--filters");
        act_filt_el.innerHTML = filterSkeleton;
        document.getElementsByClassName("productgrid--wrapper")[0].insertBefore(act_filt_el, document.getElementById("fixActiveFilters"));
        activeFiltersElements = document.getElementsByClassName("productgrid--filters");
        /* mobile */
        var act_filt_el2 = document.createElement("div");
        act_filt_el2.classList.add("productgrid--filters--mobile");
        act_filt_el2.innerHTML = filterSkeleton;
        document.getElementsByClassName("productgrid--sidebar")[0].insertBefore(act_filt_el2, document.querySelector('.productgrid--sidebar .filter-form'));
        activeFiltersElementsMobile = document.getElementsByClassName("productgrid--filters--mobile");
      }

      /* add needed elements to active filters elements */
      if (needToAdd.size > 0) {
        for (const n of needToAdd) {
          var ntaParams = new URLSearchParams();
          for (const p of currParams) {
            if (p[0].substring(0, 7) == 'filter.' && !(p[0] == n[0] && p[1] == n[1])) {
              ntaParams.append(p[0], p[1]);
            }
          }
          const ntaURL = (ntaParams.toString() == '')? '': '?' + ntaParams.toString();
          var li = document.createElement("li");
          li.classList.add('active-filter-group__item-wrapper');
          li.innerHTML = `
            <a class="active-filter-group__item" href="${location.pathname}${ntaURL}" data-url="${location.pathname}${ntaURL}" data-filter-input="">
              <span class="active-filter-text">${n[1]}</span>
              <span class="filter-icon--remove"><svg class="icon-remove " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"><path fill="currentColor" d="M6.08785659,5 L9.77469752,1.31315906 L8.68684094,0.225302476 L5,3.91214341 L1.31315906,0.225302476 L0.225302476,1.31315906 L3.91214341,5 L0.225302476,8.68684094 L1.31315906,9.77469752 L5,6.08785659 L8.68684094,9.77469752 L9.77469752,8.68684094 L6.08785659,5 Z"></path></svg>
                <span class="visually-hidden">Remove filter</span>
              </span>
            </a>
          `;
          activeFiltersElements[0].firstElementChild.insertBefore(li, activeFiltersElements[0].firstElementChild.firstChild);
          activeFiltersElementsMobile[0].firstElementChild.insertBefore(li.cloneNode(true), activeFiltersElementsMobile[0].firstElementChild.firstChild);
        }
        /* update filter count */
        var fCountMsg = document.querySelector('.utils-filter-text').innerText;
        if (origFilterCount > 0) { /* remove count from original string */
           fCountMsg = fCountMsg.substring(0, fCountMsg.lastIndexOf(" "));
        }
        console.log("origFilterCount: "+origFilterCount);
        document.getElementsByClassName('utils-filter-text')[0].innerText = fCountMsg + ' (' + (origFilterCount + needToAdd.size) + ')';
        document.getElementsByClassName('utils-filter-text')[0].setAttribute("aria-label", document.getElementsByClassName('utils-filter-text')[0].innerText);
      }
    }
  }
}
function hideOrShowStoreSpecificContent(store_id) {
  /* If store_id wasn't passed (as we do when calling function immediately after rendering an applicable section), try to get from cookie */
  if (store_id == null) {
    if (Cookies.get('gm_store')) {
      store_id = JSON.parse(Cookies.get('gm_store')).store_id;
    }
  }

  /* If store_id still not known, default to Upper Gage */
  if (store_id == null || !store_id) {
    store_id = '1';
  }
  
  var storeSpecific = document.getElementsByClassName("sto-specif");
  var storeClass = 'cur-sto-'+store_id;
  for (let i = 0; i < storeSpecific.length; i++) {
    if (storeSpecific[i].classList.contains(storeClass)) {
      if (storeSpecific[i].style.display == 'none') {
        storeSpecific[i].style.display = '';
      }
    } else {
      if (storeSpecific[i].style.display != 'none') {
        storeSpecific[i].style.display = 'none';
      }
    }   
  }
}

/* This bunch of functions followed by an event listener is for product quick shop modal integration with Red Pepper flyers.
 * We use the native Empire product quick shop functionality (including the multi-product version that comes from shoppable images),
 * but we modified empire.js.liquid to save the classes Modal and ProductQuickshop to the window to make them global, then we
 * use them here, but not in fancy classes like there were used natively. We also modified empire.js.liquid to handle not-found 
 * errors better (give feedback to user).
 */
function romarahQuickShopSidebarItemClick(event) {
	  event.preventDefault();
    const section = {id: 'romarah-multi-prod-quick-shop'};
	  var modalWrapper = document.getElementById('romarah-multi-prod-quick-shop');
	  const sidebarItemActiveClass = 'active-item';
    const currentSidebarItem = event.currentTarget;
    const productUrl = currentSidebarItem.dataset.productQuickshopUrl;
    const productId = currentSidebarItem.dataset.productId;
    const activeSidebarItems = modalWrapper.querySelectorAll(`.${sidebarItemActiveClass}`);
    modalWrapper.querySelector('[data-hotspot-modal-quickshop]').innerHTML = 
	    document.querySelector('.productitem-quickshop[data-product-quickshop]').innerHTML;
    positionSidebarArrow(currentSidebarItem);
    activeSidebarItems.forEach(item => {
      item.classList.remove(sidebarItemActiveClass);
    });
    currentSidebarItem.classList.add(sidebarItemActiveClass);
	  fetchActiveQuickShop(
	  	event,
	  	modalWrapper.querySelector('[data-hotspot-modal-quickshop]'),
	  	`[data-hotspot-section-id='${section.id}'] [data-hotspot-modal-quickshop]`,
	  	productUrl
	  );
}
function fetchActiveQuickShop(event, quickshopContainer, quickShopSelector, productUrl) {
  window.productQuickshop = new window.ProductQuickshop({
    $el: window.redpepperModal.$modalInner.find('[data-hotspot-modal-sidebar-item]'),
    id: 'red-pepper-catalog',
    modal: window.redpepperModal,
    sectionContext: 'shoppable-image',
    trigger: event.target,
    quickshopContainer: quickshopContainer,
    quickShopSelector: quickShopSelector,
    productUrl
  });
}
function positionSidebarArrow(selectedItem) {
  const section = {id: 'romarah-multi-prod-quick-shop'};
	var sidebarArrow = document.querySelector(`[data-hotspot-section-id='${section.id}']`).querySelector('[data-sidebar-arrow]');
  const itemImg = selectedItem.querySelector('[data-modal-sidebar-image]');
  const imgBounds = itemImg.getBoundingClientRect();
  const selectedItemTop = selectedItem.offsetTop;
  const middlePoint = selectedItemTop + imgBounds.height / 2;
  sidebarArrow.style.top = `${middlePoint}px`;
}
function getProductHandleFromUrl(url){
  const handleMatch = url.match(/\/products\/([^?]+)/);
  return handleMatch? handleMatch[1]: null;
}
function redpepperOpenQuickShop(event, productHandle) {
  console.log(event, productHandle);
  event = {target: document.getElementById('red-pepper-catalog')};
	// event.preventDefault();
	const sidebarItemActiveClass = 'active-item';
	if (window.productQuickshop) {
	  window.productQuickshop.unload();
	}

	/* multi-product mode */
	if (productHandle.indexOf(',') !== -1) {
		const urls = productHandle.split(',');
    var handles = [];
    urls.forEach(url => {
      var handleMatch = getProductHandleFromUrl(url);
      if (handleMatch) {
        handles.push(handleMatch);
      }
    });
    var handles_found = [];
    Promise.all(handles.map((handle, index) =>
		  fetch(`/products/${handle}?sections=custom-product-thumbnail`)
      .then(res => res.json())
		  .then(data => {
		    const wrapper = document.createElement('div');
		    wrapper.innerHTML = data['custom-product-thumbnail'];
		    var aElement = wrapper.firstElementChild.firstElementChild;
        if (aElement && aElement.dataset.productQuickshopUrl != '') { //if handle DNE, placeholder image returned so check data attrib
          handles_found.push(handle);
          aElement.setAttribute('data-index', index+1);
          aElement.setAttribute('onclick', "romarahQuickShopSidebarItemClick(event);");
          return aElement.outerHTML;
        } else {
          return "";
        }
		  })
		)).then(thumbnail_elements => {
		  const html = thumbnail_elements.join('');
		  document.getElementById('romarah-hotspot__modal-sidebar-content').innerHTML = html;
			if (window.redpepperModal) {
			  window.redpepperModal.unload();
			}
			window.redpepperModal = new window.Modal({});
			const section = {id: 'romarah-multi-prod-quick-shop'};
	    var modalWrapper = document.querySelector(`[data-hotspot-section-id='${section.id}']`);
    	var modalSelector = `[data-hotspot-modal-id='${section.id}']`;
			var quickShopSelector = `[data-hotspot-section-id='${section.id}'] [data-hotspot-modal-quickshop]`;
      modalWrapper.querySelector('[data-hotspot-modal-quickshop]').innerHTML = document.querySelector('.productitem-quickshop[data-product-quickshop]').innerHTML; // put spinner in view before opening modal, replacing any previous content
	    window.redpepperModal.open(modalSelector, 'quickshop-full hotspot__modal');
      var initialProductUrl = ''; /* some handles may not be found, so take first non-empty one, to be initial */
      for (let i = 0; i < handles.length; i++) {
        if (handles_found.indexOf(handles[i]) !== -1) {
          initialProductUrl = '/products/'+handles[i];
          break;
        }
      }
	    if (initialProductUrl != '') {
        var selectedItem = modalWrapper.querySelector(`[data-product-quickshop-url='${initialProductUrl}']`);
        selectedItem.classList.add(sidebarItemActiveClass);
        positionSidebarArrow(selectedItem);
	    } else {
        /* if no extant prods found, to make the modal render properly up to the point it will say "Product not found", pass the first handle */
        initialProductUrl = '/products/'+handles[0];
      }
	    // at this point, we're entering what was natively _fetchQuickshop()
		  const quickshopContainer = window.redpepperModal.$modalInner[0].querySelector('[data-hotspot-modal-quickshop]');
	    const spinnerContainer = modalWrapper.querySelector('.productitem-quickshop');
	    if (spinnerContainer) {
	      spinnerContainer.style.display = 'block';
	    }
	    fetchActiveQuickShop(event, quickshopContainer, quickShopSelector, initialProductUrl);
		});
	} else {
    var handleMatch = getProductHandleFromUrl(productHandle);
    if (handleMatch) {
      try {
        window.productQuickshop = new window.ProductQuickshop({
          $el: event.target,
          id: 'red-pepper-catalog',
          modalClass: 'quickshop-full',
          trigger: event.target,
          initialVariant: null,
          productUrl: '/products/'+handleMatch,
          quickShopSelector: '.productitem-quickshop[data-product-quickshop]'
        });
      } catch (error) {
        console.error('An error occurred:', error.message);
      }
    } else { /* url was not a product link, so open the page (may be a collection) in new tab */
      window.open(productHandle, '_blank');
    }
	}
}
window.addEventListener('message', (event) => {
    // event.data contains the message sent
    // event.origin contains the origin of the sender
    // event.source contains a reference to the sending window

    // const iframes = document.querySelectorAll('iframe');
    // for (const iframe of iframes) {
    //   if (event.source === iframe.contentWindow) {
    //     console.log('🔍 Message came from:', iframe.src);
    //   }
    // }
    const data_snapshot = JSON.parse(JSON.stringify(event.data));

    // console.log("clientScript" in data_snapshot ? "→ has real clientScript" : "→ no real clientScript");

    if (event.origin === 'https://app.redpepper.digital' && data_snapshot.event == 'pop-up' && data_snapshot.clientScript) {
      // console.log('Evaluating clientScript');
      // eval(data_snapshot.clientScript);
      // console.log('Received message from '+event.origin+':', data_snapshot);  
      // redpepperOpenQuickShop(event, 'sick-day-natural-beverage-immunity-shot-50ml');
    } else {
        // console.warn('Received message from unexpected origin:', event.origin, event.data);
    }    
});
